// extracted by mini-css-extract-plugin
export default {"rotating":"styles_rotating__F09pc"};